import mitt from 'mitt';
import { useRef } from 'react';
import { symbolToken } from '@servicetitan/react-ioc';
export const EVENT_BUS_TOKEN = symbolToken('EVENT_BUS_TOKEN');
export class EventBus {
    constructor() {
        Object.defineProperty(this, "job", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                on: (type, handler) => {
                    this.emitter.on(type, handler);
                },
                off: (type, handler) => {
                    this.emitter.off(type, handler);
                },
                emit: (type) => {
                    return new Promise((resolve, reject) => {
                        this.emitter.emit(type, {
                            resolve: () => resolve(),
                            reject: (reason) => {
                                if (typeof reason === 'string' || reason instanceof Error) {
                                    reject(reason);
                                }
                                else {
                                    reject();
                                }
                            },
                        });
                    });
                },
            }
        });
        Object.defineProperty(this, "emitter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: mitt()
        });
        Object.defineProperty(this, "on", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (type, handler) => {
                this.emitter.on(type, handler);
            }
        });
        Object.defineProperty(this, "off", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (type, handler) => {
                this.emitter.off(type, handler);
            }
        });
        Object.defineProperty(this, "emit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (type, data) => {
                this.emitter.emit(type, data);
            }
        });
    }
}
export function useEventBus() {
    return useRef(new EventBus()).current;
}
//# sourceMappingURL=event-bus.js.map